import React from 'react';
import { motion } from 'framer-motion';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ResearchCenters from './components/ResearchCenters';
import PolicyResearch from './components/PolicyResearch';
import Footer from './components/Footer';

function App() {
  return (
    <div>
      <Header />
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <HeroSection />
        <AboutSection />
        <ResearchCenters />
        <PolicyResearch />
      </motion.main>
      <Footer />
    </div>
  );
}

export default App;